import axios from './axios'
import {withAuthLogoutOn401} from "../utils/authTokens";

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_MCP_REGISTRY}`,
    headers: {
        'Content-Type': "application/json"
    },
});

// token on every request, refreshed/logged out on a 401; a 403 just shows a friendly message (see
// withAuthLogoutOn401) since the session is fine there, the registry is just denying the request
withAuthLogoutOn401(instance);

export const setBaseMCPUrl = (url) => {
    instance.defaults.baseURL = url;
}

export default instance